// Hero visual — autoplay looping brass-lota milk-pour video.
// User-supplied mp4 served from /hero-lota.mp4. Muted + playsInline so it
// autoplays on mobile (Safari requires both attrs).
export default function MilkPot() {
  return (
    <div className="mx-auto w-full max-w-[520px]" data-testid="hero-milk-pot">
      <div className="relative overflow-hidden rounded-[24px] border border-dd-gold/30 shadow-[0_30px_80px_-24px_rgba(201,162,76,0.35)]">
        <video
          src="/hero-lota.mp4"
          poster="/hero-lota.png"
          autoPlay
          loop
          muted
          playsInline
          preload="auto"
          aria-label="Divya Dhara — A2 Desi GIR cow milk pouring into brass lota"
          className="block w-full h-auto select-none"
          data-testid="hero-lota-video"
        />
      </div>

      <div className="mt-5 text-center font-devanagari dd-shimmer text-xl md:text-2xl" data-testid="hero-milk-pot-caption">
        हर बूंद में अमृत
      </div>
    </div>
  );
}
